import { ProductionFolderPlanningItemFieldsDto } from '../production-folder/production-folder-planning-item-fields';
import { PlanningCardFieldDescriptor } from '../planning-card-field';

/**
 * Card fields for the ProductionStep card, in display order. The header (customer/folder number/status,
 * plus the always-on "Step X" tag) is listed first as `fixed` — always shown, locked in the config
 * panel. `schedule` is a synthetic key gating the computed preferred-production-date line.
 */
export const PRODUCTION_STEP_CARD_FIELDS: PlanningCardFieldDescriptor[] = [
  { key: 'customer', labelKey: 'Doc::Planning:CardField:Customer', fixed: true },
  { key: 'number', labelKey: 'Doc::Planning:CardField:Number', fixed: true },
  { key: 'status', labelKey: 'Doc::Planning:CardField:Status', fixed: true },
  { key: 'stepName', labelKey: 'Doc::ProductionFolderLine:Step' },
  { key: 'equipment', labelKey: 'Product::Equipment:Equipment' },
  { key: 'worker', labelKey: 'Contact::Worker' },
  { key: 'manufacturer', labelKey: '::Manufacturer' },
  { key: 'responsible', labelKey: '::Responsible' },
  { key: 'schedule', labelKey: 'Doc::EndProdDate' },
];

/**
 * Typed view of a ProductionStep item's `PlanningItemDto.displayFields` payload. Mirrors the backend
 * `ProductionStepPlanningItemFieldsDto` record (Digiwall.GoliathDocuments.Planning) — keep the two in
 * sync. The planned entity is a `WorkOrderStepLine` of a ProductionFolderDoc, so it carries the same
 * parent-document fields as the base ProductionFolder source (inherited) plus the step-line specifics
 * below. `displayFields` is transported as a loosely-typed object, so the card casts it to this interface.
 */
export interface ProductionStepPlanningItemFieldsDto extends ProductionFolderPlanningItemFieldsDto {
  /** Owning ProductionFolderDoc id — the deep-link target (the item id is the step-line id). */
  productionFolderId?: string;
  /** Step order within its document — shown as a "Step X" tag so steps can be planned in sequence. */
  reference?: number;
  stepName?: string;
  equipment?: string;
  worker?: string;

  // Filter fields — ids used by the client-side board filter predicate (not shown on the card).
  equipmentId?: string;
  workerId?: string;
}
